import { map } from 'ramda';
import { nsXsf } from '@qdabra/forms-shared/xmlNamespaces';
import { hasYesAttribute } from '../../Qd/utility/xmlHelpers';
import {
    webServiceInput,
    webServiceInputFragment,
} from '../models/webServiceInput';

const parseFragment = (node) =>
    webServiceInputFragment(
        // This attribute specifies an XPath expression that identifies the elements and attributes inside the SOAP message to be replaced.
        node.getAttribute('match'),
        // This attribute specifies an XPath expression that identifies the values in the form file that will
        // replace a part of the SOAP message. If the filter attribute is present, an XML subtree MUST replace a
        // part of the SOAP message. If the filter attribute is not present, an XML node MUST replace a part of the SOAP message.
        node.getAttribute('replaceWith'),
        //  This attribute specifies whether the substituted part of the SOAP message is
        //  submitted as a string. If this attribute is not present, its value MUST be interpreted as "no".
        hasYesAttribute('sendAsString', node),
        // An XPath expression that MUST evaluate to an XML subtree in the form file. This attribute MUST be
        // present when substituting a part of the SOAP message with a subset of the form file. If this
        // attribute is not present, its value MUST be interpreted as an empty string (1).
        node.getAttribute('filter') || '',
        node.getAttribute('dataObject') || '',
    );

const parseWebServiceInput = function (operationNode) {
    const input = operationNode.getElementsByTagNameNS(nsXsf, 'input')[0];

    if (input) {
        const source = input.getAttribute('source');
        const fragNodes = input.getElementsByTagNameNS(nsXsf, 'partFragment');
        const fragments = map(parseFragment, fragNodes);

        return webServiceInput(source, fragments);
    }
    return webServiceInput('');
};

export { parseWebServiceInput };
